import { render, staticRenderFns } from "./Medications.vue?vue&type=template&id=973b2c9e&scoped=true"
import script from "./Medications.vue?vue&type=script&lang=js"
export * from "./Medications.vue?vue&type=script&lang=js"
import style0 from "./Medications.vue?vue&type=style&index=0&id=973b2c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973b2c9e",
  null
  
)

export default component.exports